/**
 * Constantes para el módulo de conceptos de movimientos bancarios.
 */

// Configuración de paginación por defecto
export const ITEMS_PER_PAGE = 10;

// Estado inicial del formulario de conceptos
export const INITIAL_MOVEMENT_CONCEPT_STATE = {
  name: '',
  code: '',
  description: '',
  is_active: true,
};

// Reglas de validación básicas
export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['name'],
  MAX_LENGTHS: {
    name: 150,
    code: 50,
    description: 255,
  },
};

// Mensajes del sistema y acciones
export const MESSAGES = {
  MOVEMENT_CONCEPT_CREATED: 'Concepto creado correctamente',
  MOVEMENT_CONCEPT_UPDATED: 'Concepto actualizado correctamente',
  MOVEMENT_CONCEPT_DELETED: 'Concepto eliminado correctamente',
  ERROR_CREATING: 'Error al crear el concepto',
  ERROR_UPDATING: 'Error al actualizar el concepto',
  ERROR_DELETING: 'Error al eliminar el concepto',
  CONFIRM_DELETE: '¿Desea eliminar este concepto? Esta acción lo inactivará.',
};
